export function parseCSV(text){
  text = text.replace(/\r\n/g,'\n').replace(/\r/g,'\n');
  const firstLine = text.split('\n')[0] || '';
  const delimiter = ((firstLine.match(/;/g)||[]).length > (firstLine.match(/,/g)||[]).length) ? ';' : ',';
  const rows = [];
  let row = [], field = '', inQuotes = false;
  for(let i=0;i<text.length;i++){
    const ch = text[i];
    if(inQuotes){
      if(ch === '"'){
        if(text[i+1] === '"'){ field += '"'; i++; } else { inQuotes = false; }
      } else field += ch;
    } else {
      if(ch === '"') inQuotes = true;
      else if(ch === delimiter){ row.push(field); field=''; }
      else if(ch === '\n'){ row.push(field); rows.push(row); row=[]; field=''; }
      else field += ch;
    }
  }
  if(field.length || row.length){ row.push(field); rows.push(row); }
  const filtered = rows.filter(r => r.length>1 || (r.length===1 && r[0].trim()!==''));
  return { headers: filtered[0] || [], rows: filtered.slice(1) };
}
